import { Appearance } from './appearanceTypes';
import button from '../../components/core/button/button.dark.module.scss';
import card from '../../components/core/card/card.dark.module.scss';
import circleButton from '../../components/core/circle-button/circle_button.dark.module.scss';
import colors from '../../components/foundation/colors/_color.dark.tokens.scss';
import gradients from '../../components/foundation/colors/_gradient.dark.tokens.scss';
import link from '../../components/core/link/link.dark.module.scss';
import typography from '../../components/foundation/typography/typography.dark.module.scss';
import tooltip from '../../components/core/tooltip/tooltip.dark.module.scss';

export const dark: Appearance = {
  button,
  card,
  circleButton,
  colors,
  gradients,
  link,
  typography,
  tooltip,
};
